<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ded">
<p class="dedf"><a class="page" id="pv"></a>For C.M.H.V.G.,</p>
<p class="ded">for her patience and forbearance</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-gere-0005.vue?abf50934